import { useEffect } from 'react';

/**
 * Lightweight SEO manager — updates document.title, meta description, canonical
 * and Open Graph tags per route without introducing an additional library.
 */
export function useSeo({ title, description, canonicalPath, image, robots }) {
  useEffect(() => {
    const fullTitle = title || 'Rare Locals | Discover Rare, Support Local';
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [k, v] = selector.replace(/[\[\]"]/g, '').split('=');
        el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    if (image) {
      setMeta('meta[property="og:image"]', 'content', image);
      setMeta('meta[name="twitter:image"]', 'content', image);
    }
    setMeta('meta[name="robots"]', 'content', robots || 'index, follow, max-image-preview:large');

    if (canonicalPath) {
      const base = 'https://rarelocals.com';
      const url = base + canonicalPath;
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', url);
      setMeta('meta[property="og:url"]', 'content', url);
    }
  }, [title, description, canonicalPath, image, robots]);
}
